import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-orders",
  "use": "rt-portal-orders-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-orders\">\r\n<g>\r\n\t<path d=\"M848,80H178c-35.2,0-64,28.8-64,64v736c0,35.2,28.8,64,64,64h538c107.8,0,196-88.2,196-196V144C912,108.8,883.2,80,848,80z\r\n\t\t M832,748c0,30.8-12.1,59.8-34.1,81.9S746.8,864,716,864H226c-17.7,0-32-14.3-32-32V192c0-17.7,14.3-32,32-32h574\r\n\t\tc17.7,0,32,14.3,32,32V748z\" />\r\n\t<g>\r\n\t\t<path d=\"M672,472H352c-22,0-40,18-40,40s18,40,40,40h320c22,0,40-18,40-40S694,472,672,472L672,472z\" />\r\n\t</g>\r\n\t<g>\r\n\t\t<path d=\"M452,655H352c-22,0-40,18-40,40s18,40,40,40h100c22,0,40-18,40-40S474,655,452,655L452,655z\" />\r\n\t</g>\r\n\t<g>\r\n\t\t<path d=\"M562,288H352c-22,0-40,18-40,40s18,40,40,40h210c22,0,40-18,40-40S584,288,562,288L562,288z\" />\r\n\t</g>\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/orders.svg
// module id = 1828
// module chunks = 228